import { hFetch } from './hFetch';

type CreateTaskChecklistAssignmentArgs = {
  taskChecklistId: number;
  contactId: number;
};

export const createTaskChecklistAssignment = async ({
  taskChecklistId,
  contactId,
}: CreateTaskChecklistAssignmentArgs) => {
  return (await hFetch({
    url: `/api/task_checklists/${taskChecklistId}/task_checklist_assignments`,
    method: 'POST',
    payload: { contact_id: contactId },
  })) as TaskChecklistAssignmentResult;
};

type TaskChecklistAssignmentResult = {
  status: 'success' | 'error';
  message?: string;
};
